import { css } from "@compiled/react";

import TabGroup, {
    IndividualTabPropsCustom,
    TabColorProps
} from "@/components/wpl/tab-group/src";
import { Row } from "@/libraries/wpl/foundations/src";

import { Boards, Timeline, Reports, Automation } from "./content";

const tabStyles: TabColorProps = {
    defaultBG: "n0",
    defaultText: "n900",
    hoverBG: "n0",
    hoverText: "n900",
    activeBG: "b50",
    activeText: "n900"
};

const tabCustomStyles = css({
    "marginTop": "40px",
    "marginBottom": "60px",

    '.tab-group .tab-group-inner button[aria-selected="false"]': {
        color: "#6b778c"
    },

    ".tab-group .tab-group-inner": {
        marginBlockEnd: "20px"
    },

    ".tab-group .tab-group-inner button": {
        "border": "1px solid transparent",
        "fontSize": "0.875rem",
        "@media (min-width: 1024px)": {
            fontSize: "1.25rem"
        }
    },

    ".tab-group .tab-group-inner button:hover": {
        border: "1px solid #deebff"
    },

    ".tab-group .tab-panel h2": {
        "color": "#253858",
        "fontSize": "1.5rem",

        "@media (min-width: 758px)": {
            fontSize: "2.25rem"
        }
    }
});

const tabSectionTitleStyles = css({
    "textAlign": "center",
    "fontSize": "1.5rem",
    "marginBlockEnd": "40px",
    "fontWeight": "500",
    "color": "#253858",

    "@media(min-width: 768px)": {
        fontSize: "2.25rem"
    }
});

const Tabs = () => {
    const tabs: IndividualTabPropsCustom[] = [
        {
            textLabel: "Boards",
            id: "boards",
            component: Boards()
        },
        {
            textLabel: "Timeline",
            id: "timeline",
            component: Timeline()
        },
        {
            textLabel: "Reports",
            id: "reports",
            component: Reports()
        },
        {
            textLabel: "Automation",
            id: "automation",
            component: Automation()
        }
    ];

    return (
        <div css={tabCustomStyles}>
            <Row layout="12">
                <h2 css={tabSectionTitleStyles}>
                    Discover the features that make Jira so easy to use
                </h2>
            </Row>
            <TabGroup
                tabContentType="custom"
                tabs={tabs}
                id="tabs"
                label="tabs"
                colors={tabStyles}
            />
        </div>
    );
};

export default Tabs;
